import { createFeature, createReducer, on } from '@ngrx/store';
import { DEFAULT_AGENT_MODEL_ID } from '../../services/agent-models';
import { KanbanColumn, normalizeBoard } from './tickets.models';
import { TicketsActions } from './tickets.actions';

export interface TicketsState {
  board: KanbanColumn[];
  dirty: boolean;
  loading: boolean;
  error: string | null;
  saving: boolean;
  saveError: string | null;
  lastSavedAt: number | null;
  executionModelId: string;
}

export const initialTicketsState: TicketsState = {
  board: [],
  dirty: false,
  loading: false,
  error: null,
  saving: false,
  saveError: null,
  lastSavedAt: null,
  executionModelId: DEFAULT_AGENT_MODEL_ID,
};

export const ticketsFeature = createFeature({
  name: 'tickets',
  reducer: createReducer(
    initialTicketsState,
    on(TicketsActions.loadStarted, (s): TicketsState => ({ ...s, loading: true, error: null })),
    on(TicketsActions.boardLoaded, (s, { columns }): TicketsState => ({ ...s, board: normalizeBoard(columns), dirty: false, loading: false, error: null })),
    on(TicketsActions.loadFailed, (s, { error }): TicketsState => ({ ...s, loading: false, error })),
    on(TicketsActions.setBoardDraft, (s, { columns }): TicketsState => ({ ...s, board: normalizeBoard(columns), dirty: true })),
    on(TicketsActions.saveBoardStarted, (s): TicketsState => ({ ...s, saving: true, saveError: null })),
    on(TicketsActions.saveBoardSucceeded, (s, { savedAt }): TicketsState => ({ ...s, saving: false, dirty: false, lastSavedAt: savedAt })),
    on(TicketsActions.saveBoardFailed, (s, { error }): TicketsState => ({ ...s, saving: false, saveError: error })),
    on(TicketsActions.setExecutionModelId, (s, { modelId }): TicketsState => ({
      ...s,
      executionModelId: String(modelId ?? '').trim() || DEFAULT_AGENT_MODEL_ID,
    }))
  ),
});
